import { render, staticRenderFns } from "./ProfileSecurity.vue?vue&type=template&id=4c1630d9&"
import script from "./ProfileSecurity.vue?vue&type=script&lang=js&"
export * from "./ProfileSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1630d9')) {
      api.createRecord('4c1630d9', component.options)
    } else {
      api.reload('4c1630d9', component.options)
    }
    module.hot.accept("./ProfileSecurity.vue?vue&type=template&id=4c1630d9&", function () {
      api.rerender('4c1630d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/ProfileSecurity.vue"
export default component.exports